var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83203 4.125C1.83203 3.42881 2.10859 2.76113 2.60088 2.26884C3.09316 1.77656 3.76084 1.5 4.45703 1.5H20.207C20.9032 1.5 21.5709 1.77656 22.0632 2.26884C22.5555 2.76113 22.832 3.42881 22.832 4.125V19.875C22.832 20.5712 22.5555 21.2389 22.0632 21.7312C21.5709 22.2234 20.9032 22.5 20.207 22.5H4.45703C3.76084 22.5 3.09316 22.2234 2.60088 21.7312C2.10859 21.2389 1.83203 20.5712 1.83203 19.875V4.125Z",
    stroke: "url(#paint0_linear_1180_967)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 1.5V4.78125C12.332 4.9553 12.2629 5.12222 12.1398 5.24529C12.0167 5.36836 11.8498 5.4375 11.6758 5.4375C11.1536 5.4375 10.6529 5.64492 10.2837 6.01413C9.91445 6.38335 9.70703 6.88411 9.70703 7.40625C9.70703 7.92839 9.91445 8.42915 10.2837 8.79837C10.6529 9.16758 11.1536 9.375 11.6758 9.375C11.8498 9.375 12.0167 9.44414 12.1398 9.56721C12.2629 9.69028 12.332 9.8572 12.332 10.0312V12M12.332 12V13.9688C12.332 14.1428 12.4012 14.3097 12.5242 14.4328C12.6473 14.5559 12.8142 14.625 12.9883 14.625C13.5104 14.625 14.0112 14.8324 14.3804 15.2016C14.7496 15.5708 14.957 16.0716 14.957 16.5938C14.957 17.1159 14.7496 17.6167 14.3804 17.9859C14.0112 18.3551 13.5104 18.5625 12.9883 18.5625C12.8142 18.5625 12.6473 18.6316 12.5242 18.7547C12.4012 18.8778 12.332 19.0447 12.332 19.2188V22.5M12.332 12H14.3008C14.4748 12 14.6417 11.9309 14.7648 11.8078C14.8879 11.6847 14.957 11.5178 14.957 11.3438C14.957 10.8216 15.1645 10.3208 15.5337 9.95163C15.9029 9.58242 16.4036 9.375 16.9258 9.375C17.4479 9.375 17.9487 9.58242 18.3179 9.95163C18.6871 10.3208 18.8945 10.8216 18.8945 11.3438C18.8945 11.5178 18.9637 11.6847 19.0867 11.8078C19.2098 11.9309 19.3767 12 19.5508 12H22.832M12.332 12H10.3633C10.1892 12 10.0223 12.0691 9.89924 12.1922C9.77617 12.3153 9.70703 12.4822 9.70703 12.6562C9.70703 13.1784 9.49961 13.6792 9.1304 14.0484C8.76119 14.4176 8.26043 14.625 7.73828 14.625C7.21614 14.625 6.71538 14.4176 6.34616 14.0484C5.97695 13.6792 5.76953 13.1784 5.76953 12.6562C5.76953 12.4822 5.70039 12.3153 5.57732 12.1922C5.45425 12.0691 5.28733 12 5.11328 12H1.83203",
    stroke: "url(#paint1_linear_1180_967)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1180_967",
    x1: 1.45102,
    y1: 12.4405,
    x2: 23.1743,
    y2: 12.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1180_967",
    x1: 1.45102,
    y1: 12.4405,
    x2: 23.1743,
    y2: 12.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroove);
export default __webpack_public_path__ + "static/media/groove.f2ac6d1c07b54a1e7633f90c9d42c3fb.svg";
export { ForwardRef as ReactComponent };